/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerModule } from '../color-picker/color-picker.module';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { MaterialModule } from '../material/material-module';
import { PresentationModule } from '../presentation-components/presentation.module';
import { UtilityComponentsModule } from '../utility-components/utility-components.module';
import { AddEditLocationComponent } from './components/project-location-dialog/add-edit-location.component';
import { ProjectLocationDialogComponent } from './components/project-location-dialog/project-location-dialog.component';
import { AddEditMemberComponent } from './components/project-member-dialog/add-edit-member.component';
import { ProjectMemberDialogComponent } from './components/project-member-dialog/project-member-dialog.component';
import { AddEditRoleComponent } from './components/project-role-dialog/add-edit-role.component';
import { ProjectRoleDialogComponent } from './components/project-role-dialog/project-role-dialog.component';
import { AutomationIdDirective } from '../../shared/directives/automation-id/automation-id.directive';

@NgModule({
	declarations: [
		ProjectMemberDialogComponent,
		ProjectLocationDialogComponent,
		ProjectRoleDialogComponent,
		AddEditMemberComponent,
		AddEditLocationComponent,
		AddEditRoleComponent,
	],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MaterialModule,
		DialogReusableModule,
		UtilityComponentsModule, // <--- this module is gross, only need AutoHideLabel
		PresentationModule,
		ColorPickerModule,
		AutomationIdDirective,
	],
	exports: [ProjectMemberDialogComponent, ProjectLocationDialogComponent, ProjectRoleDialogComponent],
})
export class ProjectDialogsModule {}
